export const analyticsRouteNames = {
  default: 'analytics-v2',
}
